import { createAction } from "@reduxjs/toolkit";
import * as types from "./types";

export const setNavigation = createAction(
  types.SET_NAVIGATED_ROUTE,
  (route) => ({
    payload: route,
  })
);
